import React, { useState, useEffect } from 'react';
import { PaymentRequestButtonElement, useStripe } from '@stripe/react-stripe-js';
import styles from './Checkout.module.scss'
import { toCents } from '../../../utils/toCents';

const Stripe = ({ cart, setValue, setShowShipping, usStates, setOrderErrors, handleSubmit, onSubmit, unregister, register, skipShipping }) => {
  const stripe = useStripe();
  const [paymentRequest, setPaymentRequest] = useState(null);

  const setShippingInfo = (ev) => {
    setValue("payment_method", "stripe");
    setShowShipping(true);

    if (skipShipping || !ev.shippingAddress) return;

    const state = usStates.find(s => s.value === ev.shippingAddress.region);
    setValue('shipping_address', ev.shippingAddress.addressLine[0])
    setValue('shipping_address2', ev.shippingAddress.addressLine[1])
    setValue('shipping_state', state)
    setValue('shipping_city', ev.shippingAddress.city)
    setValue('shipping_zip', ev.shippingAddress.postalCode)
  }

  const shippingInCents = (cart) => {
    if (!cart || !cart.shipping) return 1;

    return toCents(cart.shipping);
  }

  useEffect(() => {
    if (stripe) {
      const pr = stripe.paymentRequest({
        country: 'US',
        currency: 'usd',
        total: {
          label: 'Shoob Photography Purchase Total',
          // Must agree to the cent with the PaymentIntent the server creates, or the
          // customer is charged something other than the sheet shows.
          amount: cart && toCents(cart.apiTotal) || 1,
        },
        requestPayerName: true,
        requestPayerEmail: true,
        requestShipping: !skipShipping,
        ...(skipShipping ? {} : {
          shippingOptions: [
            {
              id: 'shipping',
              label: `Shipping - $${cart && cart.shipping.toFixed(2) || 0}`,
              detail: '',
              amount: shippingInCents(cart) || 1,
            },
          ],
        })
      });

      // Check the availability of the Payment Request API.
      pr.canMakePayment().then(result => {
        if (result) {
          setPaymentRequest(pr);
        }
      });

      pr.on('paymentmethod', async (e) => {
        const { client_secret, error } = await fetch(
          `/api/v1/carts/${cart.id}/create_payment_intent`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              paymentMethodType: 'card',
              currency: 'usd',
            }),
          }
        ).then((response) => response.json())

        if (error) {
          setOrderErrors([e.message || 'There was an error processing your payment. Please try again or use another payment method.'])
          e.complete('fail');
          return;
        }

        e.complete('success');

        setShippingInfo(e);
        window.stripeOrder = e;
        window.stripeKey = client_secret;
      });
    }
  }, [stripe]);

  if (paymentRequest) {
    return (
      <div className={styles.radioGroup}>
        <label className={styles.paymentLabel}>
          <input
            {...register("payment_method", { required: true })}
            type="radio"
            onChange={() => unregister(
              ["name_on_card", "card_number", "card_expires_on", "card_verification",
                "address", "address2", "city", "state", "zip_code", "payment_method"])}
            value="stripe" />
            <span>
              <PaymentRequestButtonElement options={{paymentRequest}} />
            </span>
        </label>
      </div>
    );
  }

  return <div />;
}

export default Stripe;
